import { Globe } from "lucide-react";

export default function ConfirmCard({
  onConfirm,
  onDecline,
}: {
  onConfirm: () => void;
  onDecline: () => void;
}) {
  return (
    <div className="mt-2 rounded-lg border border-border bg-muted/50 p-3">
      <div className="flex items-center gap-1.5 text-sm font-medium">
        <Globe className="h-4 w-4 text-muted-foreground" /> 외부 웹 검색을 시도할까요?
      </div>
      <p className="mt-1 text-xs text-muted-foreground">
        외부 검색 결과는 사내 정보의 정확성을 보장하지 않습니다.
      </p>
      <div className="mt-2 flex gap-2">
        <button
          onClick={onConfirm}
          className="rounded-md bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground"
        >
          검색하기
        </button>
        <button
          onClick={onDecline}
          className="rounded-md border border-border px-3 py-1.5 text-xs font-medium"
        >
          취소
        </button>
      </div>
    </div>
  );
}
